import {default as ModalBootstrap} from 'react-bootstrap/Modal';
import {Button} from "react-bootstrap";
import { useEffect, useRef } from 'react';
import { useTranslation } from "../../hooks/useTranslation";

export default function Modal({show, children, title, buttons = null, width = null, handleClose}) {
    const { t } = useTranslation();
    const modalRef = useRef();

    const style = {};
    if (width) {
        style["--bs-modal-width"] = width;
    }

    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                // Najdi konkrétně tento modal přes ref
                const modalContainer = modalRef.current;
                if (modalContainer) {
                    const modalElement = modalContainer.querySelector('.modal');
                    if (modalElement) {
                        modalElement.setAttribute('tabindex', '0');
                        const firstInput = modalElement.querySelector('input');
                        if (firstInput) {
                            firstInput.focus();
                        }
                    }
                }
            }, 50);

            return () => clearTimeout(timer);
        }
    }, [show]);

    return (
        <div ref={modalRef}>
            <ModalBootstrap
                show={show}
                onHide={handleClose}
                style={style}
                autoFocus={true}
            >
                <ModalBootstrap.Header closeButton>
                    <ModalBootstrap.Title>{title}</ModalBootstrap.Title>
                </ModalBootstrap.Header>

                <ModalBootstrap.Body>{children}</ModalBootstrap.Body>
                <ModalBootstrap.Footer>
                    {buttons !== null && (buttons)}
                    <Button variant="light" onClick={handleClose}>
                        {t("common.close")}
                    </Button>
                </ModalBootstrap.Footer>
            </ModalBootstrap>
        </div>
    );
}